export const transformPrflDtlResponseToUnlistedVendorFormat = (response) => {
  return {
    getProfileList: {
      profiles: response.data.data.prflDtlByPrflGuidInput.list.map(profile => ({
        userID: profile.usrid || "",
        profileID: profile.prflguid || "",
        firstName: profile.frstnm || "",
        lastName: profile.lastnm || "",
        middleName: profile.midnm || "",
        email: profile.email || "",
        profileRole: profile.prflrole || "",
        parentCompanyName: profile.prntcmpnynm || "",
        parentEIN: profile.prntein || "",
        status: profile.status || "",
        parentCompanyLegalEntityID: profile.prntcmpnylglenttyid || "",
        usbRelationship: profile.usbrltnshp,
        phoneNumbers: {
          mobilePhone: profile.mbilephn || "",
          businessPhone: profile.bsnsphn
        },
        address: {
            addressLine1: profile.addrline1 || "",
            addressLine2: profile.addrline2 || "",
            city: profile.city || "",
            state: profile.ste || "",
            zipCode: profile.zip || "",
            country: profile.cnty || ""
        }
      })),
      pageMeta: {
        total: response.data.data.prflDtlByPrflGuidInputCount.totalRecords
      }
    }
  };
}
